import React, { useState, useEffect } from 'react';

const TimerButton: React.FC = () => {
  const [hasStarted, setHasStarted] = useState(false);
  const [timeLeft, setTimeLeft] = useState(5 * 60); // 5 minutes in seconds

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [timeLeft]);

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const handleStartTimer = () => {
    setTimeLeft(5 * 60); // Reset the timer to 5 minutes
    setHasStarted(true);
  };

const handleNewGame = () => {
    window.location.reload();
};

  return (
    <div>
        {hasStarted}
        {!hasStarted ?? (<button className='timerButton' onClick={handleStartTimer}>Start Timer</button>)}
        {(hasStarted && timeLeft > 0) ?? (<button className='timerButton' disabled={true}>{formatTime(timeLeft)}</button>)}
        {(hasStarted && timeLeft <= 0) ?? (<button className='timerButton' onClick={handleNewGame}>Start New Game</button>)}


        {!hasStarted ? (
                <button className='timerButton primary' onClick={handleStartTimer}>Start Timer</button>
            ) : (hasStarted && timeLeft > 0) ? (
                <button className='timerButton playing'>{formatTime(timeLeft)}</button>
            ) : (<button className='timerButton warning'>Time is up!</button>)}

<br />
<button className='timerButton' onClick={handleNewGame}>Start New Game</button>
    </div>
  );
};

export default TimerButton;
